import {resizeEvent} from './global';

/**
 * リサイズイベントの登録
 * @return {Void}
 */
export default () => {
    let isResizing = false;
    let timer = 0;

    // イベントの発火
    const dispatchResizeEvent = (eventName) => {
        const event = document.createEvent('Event');

        // IE11対策 かつ `initEvent`は廃止予定のため回避
        if (typeof event.initEvent === 'function') {
            event.initEvent(eventName, false, true);
        }

        window.dispatchEvent(event);
    };

    window.addEventListener('resize', () => {
        if (isResizing) {
            return;
        }

        isResizing = true;
        clearTimeout(timer);
        dispatchResizeEvent(resizeEvent.start);

        // リサイズ後、横幅を再取得
        timer = window.setTimeout(() => {
            isResizing = false;
            dispatchResizeEvent(resizeEvent.end);
        }, 500);
    });
};
